import { updateStats } from "../common";

(() => {
  if ("undefined" == typeof FEATURED_CATEGORY) {
    return;
  }

  updateStats(`menu_${FEATURED_CATEGORY}`);

  let currentCategory;
  window.currentCategory = currentCategory;

  $("#menu-toggle").on("click", () =>
    $("#menu-text").text(
      $("#menu-text").text() == "Abrir Carta" ? "Fechar Carta" : "Abrir Carta"
    )
  );

  $(".btn-menu-category").on("click", function () {
    let category = $(this).attr("data-category");

    if (currentCategory !== category) {
      updateStats(`menu_${category}`);
    }

    activeCategoriesButton(category);
  });

  $(".btn-products-all").on("click", function () {
    let category = $(this).attr("data-category");
    showProducts(category, false);
  });

  $(".btn-products-featured").on("click", function () {
    let category = $(this).attr("data-category");
    showProducts(category);
  });

  const activeCategoriesButton = (category) => {
    $(".btn-menu-category").removeClass("active");
    $(`.btn-menu-category[data-category='${category}']`).addClass("active");
    showProducts(category);
    currentCategory = category;
  };

  const showProducts = (category, featured = true) => {
    $(".section-products").hide();
    $(`#section-${category}-${featured ? "featured" : "all"}`).show();
  };

  $("#featured-category").on("change", () => {
    $("#featured-category-form").trigger("submit");
  });

  $(() => activeCategoriesButton(FEATURED_CATEGORY));
})();
